module.exports = __webpack_public_path__ + "static/media/wellness-589772_1280.8eee1b38.jpg";